<div class="date-range-bar">
    <div class="date-range-bar__labels">
        <div class="date-range-bar__label">
            <span class="date-range-bar__label-type">Start</span>
            <span class="date-range-bar__label-value">
                {{ startDate() | tzDate: timezone() }}
            </span>
        </div>
        <div class="date-range-bar__label">
            @if (endDate()) {
                <span class="date-range-bar__label-value">
                    {{ endDate() | tzDate: timezone() }}
                </span>
                <span class="date-range-bar__label-type">End</span>
            } @else {
                <span class="date-range-bar__label-value">Ongoing</span>
            }
        </div>
    </div>
    <mat-progress-bar
        mode="determinate"
        [value]="value()"
        [class.date-range-bar__progress--color-disabled]="colorDisabled()"
        [class.date-range-bar__progress--complete]="
            value() === 100 && endDate() !== null
        "
    />
</div>
